import React, { useState } from "react";
import PropertyCompletedTable from "./pc-task-table";
import PropertyTaskService from "../../../services/hoa-property-task-service";
import { useFinishedTaskDataStore } from "../../../store/useDataStore";
import PropertyTaskCompletedFilterComponent from "./pc-filter-component";

export default function PropertyCompletedDashboard() {
	const { updateDataList, option, resetDataList } = useFinishedTaskDataStore();
	const [loading, setLoading] = useState(false);

	const fetchData = async (option: any = {}, pageNo: number = 1, isLastPage: boolean = false) => {
		setLoading(true);
		const loadingDataNumber = Math.ceil((window.innerHeight - 248) / 60);
		const dataResult = await PropertyTaskService.getPropertyTasksWhichAreFinished(
			pageNo,
			loadingDataNumber,
			option
		);

		const data = dataResult.data;

		if (data.length > 0 && data.length === loadingDataNumber) {
			updateDataList(data, pageNo, isLastPage, option);
		} else {
			updateDataList(data, pageNo, true, option);
		}
		setLoading(false);
	};

	return (
		<div>
			<PropertyTaskCompletedFilterComponent
				option={option}
				fetchData={fetchData}
				resetDataList={resetDataList}
			/>
			<PropertyCompletedTable
				loading={loading}
				fetchData={fetchData}
				setLoading={setLoading}
			/>
		</div>
	);
}
